import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import misc from '../../misc';

export class ClientEdit extends Component {
  renderHeading() {
    const { initialValues, isLoading, submitting } = this.props;

    if (!submitting && isLoading) {
      return null;
    }
    if (typeof initialValues === 'undefined') {
      return <h5>New Client</h5>;
    }

    return (
      <h5>{`${initialValues.get('firstName')} ${initialValues.get(
        'lastName'
      )}`}</h5>
    );
  }

  renderForm() {
    const {
      handleSubmit,
      error,
      pristine,
      submitting,
      isLoading,
      initialValues
    } = this.props;
    return (
      <div className="row justify-content-md-center">
        <form
          className="container"
          onSubmit={handleSubmit(this.props.onSubmit)}
        >
          {this.renderHeading()}
          {error && <misc.components.Alert message={error} />}
          <div className="row">
            <div className="col">
              <Field
                component={misc.components.FormField}
                name="firstName"
                id="firstName"
                type="input"
                label="First name"
              />
            </div>
            <div className="col">
              <Field
                component={misc.components.FormField}
                name="lastName"
                id="lastName"
                type="input"
                label="Last name"
                required
              />
            </div>
          </div>
          <Field
            component={misc.components.FormField}
            name="email"
            id="email"
            type="input"
            label="Email address"
            required
          />
          <Field
            component={misc.components.FormField}
            name="phone"
            id="phone"
            type="input"
            label="Mobile number"
            required
          />
          <Field
            component={misc.components.FormField}
            name="notes"
            id="notes"
            type="textarea"
            label="Notes"
            rows={4}
          />
          <div className="row">
            <div className="col">
              <Link
                to={
                  typeof initialValues === 'undefined'
                    ? '/clients'
                    : `/clients/${initialValues.get('id')}`
                }
                className="btn btn-secondary btn-block"
              >
                Cancel
              </Link>
            </div>
            <div className="col">
              <misc.components.LoadingButton
                disabled={pristine || submitting}
                loading={isLoading}
              >
                {typeof initialValues === 'undefined' ? 'Add' : 'Save'}
              </misc.components.LoadingButton>
            </div>
          </div>
        </form>
      </div>
    );
  }

  render() {
    const { isLoading, isError, errorMessage, submitting } = this.props;
    return (
      <div className="col-md-9 content">
        {!submitting && isLoading && <misc.components.LoadingAlert />}
        {isError && <misc.components.Alert message={errorMessage} />}
        {this.renderForm()}
      </div>
    );
  }
}

ClientEdit.propTypes = {
  initialValues: ImmutablePropTypes.contains({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string
  }),
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

ClientEdit.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export const validate = values => {
  const errors = {};

  // First name
  if (!values.get('firstName') || !values.get('firstName').trim()) {
    errors.firstName = 'First name is required.';
  }

  // Last name
  if (!values.get('lastName') || !values.get('lastName').trim()) {
    errors.lastName = 'Last name is required.';
  }

  // Email
  if (!values.get('email')) {
    errors.email = 'Email address is required.';
  } else if (!misc.lib.validators.validateEmail(values.get('email'))) {
    errors.email = 'Email address is invalid.';
  }

  // Phone
  if (
    values.get('phone') &&
    !misc.lib.validators.validatePhone(values.get('phone'))
  ) {
    errors.phone = 'Phone number is invalid.';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'clientForm'
})(ClientEdit);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientEdit.js